import React from 'react'
import {Redirect} from '@reach/router'
import {useSelector} from 'react-redux'

export const PrivateRoute = (props) => {
    const {user} = useSelector((state) => state.auth)
    const {as: Comp, location} = props
    const change_password_path = '/dashboard/profile/password'
    const {pathname} = location
    const isPasswordPage = pathname === change_password_path

    if (user) {
        if (user.need_to_change_password && !isPasswordPage) {
            return <Redirect to={change_password_path} noThrow/>
        } else {
            return (
                <>
                    <Comp {...props} />
                </>
            )
        }
    }
    return <Redirect to={'/'} noThrow/>
}

export const AdminOnlyRoute = (props) => {
    const {user} = useSelector((state) => state.auth)
    const {role, is_superuser} = user
    const {as: Comp} = props
    if (user && (role === 'SuperUser' || is_superuser || role === "Privileged")) {
        return (
            <>
                <Comp {...props} />
            </>
        )
    } else {
        return <Redirect to={'/dashboard'} noThrow/>
    }
}
